import { render, staticRenderFns } from "./HeverAmbassadorsCard.vue?vue&type=template&id=60404c25&scoped=true"
import script from "./HeverAmbassadorsCard.vue?vue&type=script&lang=js"
export * from "./HeverAmbassadorsCard.vue?vue&type=script&lang=js"
import style0 from "./HeverAmbassadorsCard.vue?vue&type=style&index=0&id=60404c25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60404c25",
  null
  
)

export default component.exports